import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { environment } from '../../../../environments/environment';

export class HttpProviderService {

  constructor(private http: HttpClient, private providerPath: string) {}

  /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
  sendGetRequest(path: string, headers: HttpHeaders, params: HttpParams) {
    const requestOptions = {
      headers: headers,
      params: params,
      observe: "response" as 'body',
    };
    /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
    return this.http.get(`${this.providerPath}${path}`, requestOptions);
  }

  /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
  sendPostRequest(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    const requestOptions = {
      headers: headers,
      observe: "response" as 'body',
      params: params
    };
    /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
    return this.http.post(`${this.providerPath}${path}`, body, requestOptions);
  }

  /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
  sendPatchRequest(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    const requestOptions = {
      headers: headers,
      observe: "response" as 'body',
      params: params
    };
    /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
    return this.http.patch(`${this.providerPath}${path}`, body, requestOptions);
  }

  /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
  sendPutRequest(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    const requestOptions = {
      headers: headers,
      observe: "response" as 'body',
      params: params
    };
    /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
    return this.http.put(`${this.providerPath}${path}`, body, requestOptions);
  }

  /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
  sendDeleteRequest(path: string, headers: HttpHeaders, params: HttpParams) {
    const requestOptions = {
      headers: headers,
      observe: "response" as 'body',
      params: params
    };
    /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
    return this.http.delete(`${this.providerPath}${path}`, requestOptions);
  }

}

//provider service pattern

@Injectable({
  providedIn: 'root'
})
export class MemberProviderService extends HttpProviderService {
  /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, "");
  }
}


//add endpoints here
//can be multiple(microservice pattern)
@Injectable({
  providedIn: 'root'
})
export class HHTProviderService extends HttpProviderService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL);
  }
}